import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components'
/* Redux imports */
import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
/* styled-component imports */
import {Box, Card, Flex} from "rebass";
import {Input} from "reakit";
/* custom styled-components */
import {SearchButton} from "../Base/Buttons";

const Wrapper = styled(Card)`
z-index: 9100
`;

const ButtonWrapper = styled(Box)`
	min-width: 45px;
	max-width: 45px;
`

const InputWrapper = styled(Box)`
	width: calc(100% - 45px);
	input:focus {
		outline: none;
	}
`

class PopupSearchInput extends Component {

	componentDidMount() {
		this.props.clearSearch()
	}

	handleSearchSubmit = (e) => {
		e.preventDefault()
		// const {history} = this.props;
		// // localStorage.setItem('search', this.state.searchTerm)
		// history.push({pathname: '/app/search'})
	};

	handleSearchInput = (e) => {
		const {updateSearch} = this.props;
		e.preventDefault();
		updateSearch(e.target.value)
	};

	render() {
		const {search, placeholder} = this.props;
		return (
			<Wrapper bg={'white'} boxShadow={'main'}>
				<form onSubmit={this.handleSearchSubmit} style={{width: '100%'}}>
					<Flex width={1} flexWrap={'wrap'} flexDirection={'row'}>
						<ButtonWrapper >
							<SearchButton type={'submit'}/>
						</ButtonWrapper>
						<InputWrapper>
							<Input fontWeight={600} onChange={this.handleSearchInput} value={search} placeholder={placeholder} width={'100%'}/>
						</InputWrapper>
					</Flex>
				</form>
			</Wrapper>
		);
	}
}



const mapStateToProps = state => ({
	search: searchSelectors.refreshPopupSearch(state.search),
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updatePopupSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearPopupSearch());
	},
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PopupSearchInput));